/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetHoldingsHistoricalDataRequest} from '@cash-web/protos/squareup/cash/portfolios/service.pb'
import {GetHoldingsHistoricalDataResponse} from '@cash-web/protos/squareup/cash/portfolios/service.pb'


export const getHoldingsHistoricalData = (request: GetHoldingsHistoricalDataRequest, options?: CashRequestOptions) => post<GetHoldingsHistoricalDataRequest, GetHoldingsHistoricalDataResponse>("/2.0/cash/get-holdings-historical-data", request, {...options, rejectOnError: true })